import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ios-arrow-back",
  "use": "ios-arrow-back-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"ios-arrow-back\"><path d=\"M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol